<template>
  <div
    v-if="sortedEvents && memberType !== 3"
    class="promotion-frame"
    :class="{ 'pc-event': !isMobile }"
    v-on="isMobile ? {} : { click: onPromoClick }"
  >
    <div class="promotionTitle">
      {{ $t('Bao.available_event') }}
    </div>
    <div class="promotionDescribe text-center">
      {{ $t('Bao.select_event') }}
    </div>

    <swiper
      ref="eventSwiper"
      class="promotionBox paginationFrame"
      :options="swiperOptions"
    >
      <swiper-slide
        v-for="(item, key) in sortedEvents"
        :key="key"
        class="promotionCards"
        :class="{
          'unopened-event': isUnopenedEvent(item),
          'active': isMobile && item.select && selectedEventId !== null
        }"
        :data-event-index="key"
        :data-event-id="item.id"
      >
        <div
          class="proCheckBox"
          v-on="isMobile ? { click: () => $emit('select-event', item) } : {}"
        />
        <img
          :src="item.image_deposit"
          v-on="isMobile ? { click: () => $emit('select-event', item) } : {}"
        >
      </swiper-slide>

      <div slot="pagination" class="swiper-pagination" />
      <div slot="button-prev" class="swiper-button-prev pro-arrow" />
      <div slot="button-next" class="swiper-button-next pro-arrow" />
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'DepositEventSwiper',
  components: { Swiper, SwiperSlide },
  props: {
    sortedEvents: {
      type: Array,
      default: null
    },
    selectedEventId: {
      type: [Number, String],
      default: null
    },
    memberType: {
      type: Number,
      default: 0
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    swiperOptions() {
      if (this.isMobile) {
        return {
          slidesPerView: 1.3,
          spaceBetween: 30,
          pagination: { el: '.swiper-pagination', type: 'fraction' },
          navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }
        }
      }
      return {
        spaceBetween: 30,
        pagination: { el: '.swiper-pagination', type: 'fraction' },
        navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
        breakpoints: {
          1450: { slidesPerView: 3.5 },
          1300: { slidesPerView: 2.7 },
          1120: { slidesPerView: 2.2 },
          992: { slidesPerView: 1.3 }
        }
      }
    },
    swiperInstance() {
      return this.$refs.eventSwiper?.$swiper
    }
  },
  methods: {
    isUnopenedEvent(item) {
      // 父層傳入判斷結果，由父層決定邏輯
      return this.$parent.isUnopenedEvent ? this.$parent.isUnopenedEvent(item) : false
    },
    /**
     * PC 版用事件委派，從 DOM 取得 index 後找到對應 item 再 emit。
     * 與原始 handlePromoClick 邏輯一致。
     */
    onPromoClick(event) {
      const clickedElement = event.target
      const slideElement = clickedElement.closest('.promotionCards')
      if (!slideElement) return
      if (slideElement.classList.contains('unopened-event')) return

      if (clickedElement.classList.contains('proCheckBox') || clickedElement.tagName === 'IMG') {
        const index = slideElement.dataset.eventIndex
        const item = this.sortedEvents[index]
        if (item) {
          document.querySelectorAll('.promotionCards').forEach(card => {
            card.classList.remove('active')
          })
          this.$emit('select-event', item)
          if (item.select) {
            slideElement.classList.add('active')
          }
        }
      }
    },
    /** 供父層呼叫，調整 swiper wrapper 樣式 */
    updateSwiperWrapperStyle() {
      this.$nextTick(() => {
        const swiper = this.swiperInstance
        if (!swiper) return
        const wrapper = swiper.$wrapperEl?.[0]
        if (!wrapper) return

        const threshold = this.isMobile ? 2 : 4
        if (this.sortedEvents.length < threshold) {
          wrapper.style.display = 'flex'
          wrapper.style.justifyContent = 'center'

          const slides = wrapper.querySelectorAll('.swiper-slide')
          slides.forEach((slide, i) => {
            if (this.isMobile && i === 0) {
              slide.style.margin = 'auto'
            } else if (!this.isMobile) {
              slide.style.width = 'auto'
              slide.style.paddingLeft = '30px'
              slide.style.height = '150px'
            }
          })
        }
      })
    }
  }
  // emits: ['select-event']
}
</script>
